import ReadOnlyControl from './ReadOnlyControl';
export default ReadOnlyControl;
